<!-- eslint-disable no-console -->
<template>
  <div class="team">
    <div class="tab">
      <div
        v-for="item in tabList"
        :key="item.key"
        class="tab-item"
        :class="{ active: currentShare === item.key }"
        @click="handleChangeTab(item.key)"
      >
        <span>{{ item.label }}</span>
      </div>
    </div>
    <PageTabs
      v-model:tabKey="activeKey"
      :tabName="
        currentShare === COLLECTION_SOURCE.SHARE ||
        !checkPermission(ActionListKey.TEAM_RECYCLING_BIN)
          ? 'share'
          : 'space'
      "
    >
      <template #rightExtra>
        <XSearch
          v-model="searchFrom.keyword"
          class="-mt-[6px]"
          :placeholder="$t('qing-shu-ru-guan-jian-ci')"
          @search="handleOnSearch"
        />
      </template>
      <template v-if="true">
        <div v-if="activeKey === COLLECTION_MAP.SOURCE" class="mb-[16px]">
          <TagSelect
            v-model="mediaTypeState"
            :name="
              currentShare === COLLECTION_SOURCE.TEAM
                ? 'resource_type'
                : 'resource_type_team'
            "
            :hasAll="false"
          />
        </div>
        <div
          class="content"
          :class="{ extra: activeKey === COLLECTION_MAP.SOURCE }"
        >
          <ListCard
            ref="cardListRef"
            :list="list"
            :editable-config="editableConfig"
            :show-upload="isShowUpload"
            :loading="loading.global"
            :total="total"
            :avatarJumpable="
              hasActionPermission('team_space_chengpian_avatar_route')
            "
            @select-change="onSelectChange"
            @load-more="loadMore"
            @card-click="handleCardClick"
          >
            <template #cover="{ dataSource }">
              <template
                v-if="
                  currentShare === COLLECTION_SOURCE.SHARE &&
                  dataSource.isDelete
                "
              >
                <div class="source-delete">
                  <iconpark-icon
                    name="source-delete"
                    class="icon-delete"
                  ></iconpark-icon>

                  <span class="label ml-[5px]">
                    {{ $t('yuan-wen-jian-yi-shan-chu') }}
                  </span>
                </div>
                <a-popover :content="$t('shan-chu')">
                  <div
                    class="absolute top-[10px] right-[10px] z-30 flex justify-center items-center w-[24px] h-[24px] rounded-[12px] bg-transparent hover:bg-[#FFFFFF] transition-colors"
                  >
                    <iconpark-icon
                      name="close"
                      size="16"
                      fill="grey"
                      @click.stop.prevent="
                        handleDeleteShare([dataSource.id?.toString()])
                      "
                    ></iconpark-icon>
                  </div>
                </a-popover>
              </template>
              <template v-else>
                <!-- 收藏 -->
                <div v-if="!isRecyclingBin" class="tool">
                  <div
                    v-if="
                      showBrand() &&
                      (dataSource.isBrand
                        ? true
                        : !getSelfPerson(dataSource) &&
                          checkPermission(ActionListKey.TEAM_BRAND_GUIDELINES))
                    "
                    class="icon-item brand"
                    :class="{
                      favorite: dataSource.isBrand,
                    }"
                    @click.stop="
                      handleCancelBrand([dataSource.id], dataSource.isBrand)
                    "
                  >
                    <a-popover
                      :content="
                        dataSource.isBrand
                          ? $t('yi-she-wei-pin-pai-gui-fan')
                          : $t('she-wei-pin-pai-gui-fan')
                      "
                    >
                      <iconpark-icon
                        name="icon-crown"
                        size="16"
                      ></iconpark-icon>
                    </a-popover>
                  </div>
                  <div
                    v-if="!getSelfPerson(dataSource)"
                    class="icon-item collection"
                    :class="{
                      favorite: dataSource.like,
                    }"
                  >
                    <XCollect
                      v-model="dataSource.like"
                      class="collect"
                      :data="dataSource"
                      :params="getCollectParams(dataSource)"
                      :class="{ active: dataSource.like }"
                    />
                  </div>
                  <!-- 分享 -->
                  <div
                    v-if="
                      mediaTypeState !== RESOURCE_TYPE.PERSON &&
                      activeKey === COLLECTION_MAP.SOURCE
                    "
                    class="share"
                  >
                    <TemplateShare
                      :id="dataSource?.id"
                      :isCard="true"
                      :title="getCardName(true)"
                      :linkUrl="
                        activeKey !== COLLECTION_MAP.PIECES
                          ? undefined
                          : getShareUrl(dataSource)
                      "
                      :disabled="getSelfPerson(dataSource)"
                      :disabledText="
                        $t(
                          'ge-ren-chuang-jian-de-ren-wu-zan-bu-zhi-chi-fen-xiang'
                        )
                      "
                      :showExtra="activeKey === COLLECTION_MAP.PIECES"
                      :params="{
                        model_type: activeKey,
                        is_user_upload: dataSource.is_user_upload,
                        share_ids: [dataSource.model_id],
                        ...(activeKey === COLLECTION_MAP.SOURCE && {
                          media_type:
                            mediaTypeState === RESOURCE_TYPE.MATERIAL
                              ? dataSource.media_type
                              : undefined,
                          resource_type: mediaTypeState,
                        }),
                      }"
                      :trackParams="{
                        target: getTargetForEventTracking(
                          activeKey,
                          mediaTypeState
                        ),
                        dataId: dataSource.id,
                        dataTitle: dataSource.title,
                      }"
                      :shareToInnerUser="
                        activeKey === COLLECTION_MAP.SOURCE &&
                        mediaTypeState === RESOURCE_TYPE.PERSON
                          ? false
                          : true
                      "
                      :shareToOuterUser="
                        hasActionPermission(
                          'personal_space_share_to_outer_user'
                        )
                      "
                      @click.stop
                    />
                  </div>
                </div>
                <!-- 作品预览 -->
                <div v-if="activeKey === COLLECTION_MAP.OPUS" class="opus">
                  <ProjectEye :data="dataSource" />
                </div>
                <div
                  v-if="activeKey === COLLECTION_MAP.PIECES_TEMPLATE"
                  class="template"
                  @click.stop.prevent="handleUseTemplate(dataSource)"
                >
                  <iconpark-icon
                    v-if="dataSource?.limited"
                    name="eye"
                    class="icon-edit mb-[3px]"
                  ></iconpark-icon>
                  <iconpark-icon
                    v-else
                    name="edit"
                    class="icon-edit"
                  ></iconpark-icon>
                  <span class="label">
                    {{
                      dataSource?.limited
                        ? $t('ban-quan-xiang-guan-zhi-du-mo-ban')
                        : $t('chuang-zuo-tong-kuan')
                    }}
                  </span>
                </div>
                <Player
                  v-if="
                    dataSource.url?.[0] &&
                    (COLLECTION_MAP.PIECES === activeKey ||
                      (activeKey === COLLECTION_MAP.SOURCE &&
                        [RESOURCE_TYPE.HEAD, RESOURCE_TYPE.END].includes(
                          mediaTypeState
                        )))
                  "
                  ref="player"
                  class="play-button absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] opacity-0"
                  :url="dataSource.url?.[0]"
                  @click="handlePlayVideo(dataSource)"
                />
                <MusicPlayer
                  v-if="
                    activeKey === COLLECTION_MAP.SOURCE &&
                    [RESOURCE_TYPE.MUSIC, RESOURCE_TYPE.SOUND_EFFECT].includes(
                      mediaTypeState
                    )
                  "
                  :id="dataSource.id"
                  :url="dataSource?.url?.[0]"
                />
              </template>
              <template
                v-if="
                  activeKey === COLLECTION_MAP.SOURCE &&
                  (mediaTypeState === RESOURCE_TYPE.STUDIO ||
                    mediaTypeState === RESOURCE_TYPE.PERSON)
                "
              >
                <Eye
                  :data="dataSource"
                  class="opus"
                  :class="{
                    '!right-[10px]': getSelfPerson(dataSource),
                  }"
                />
              </template>
              <ResourceLabel
                v-if="isRecyclingBin"
                :record="dataSource"
                class="absolute top-[10px] left-[10px]"
              />
            </template>
            <template #batch="{ checkable, checkedList }">
              <div class="flex gap-x-[20px] mr-[8px]">
                <a-button
                  v-if="
                    [
                      COLLECTION_MAP.PIECES,
                      COLLECTION_MAP.PIECES_TEMPLATE,
                    ].includes(activeKey) &&
                    currentShare === COLLECTION_SOURCE.SHARE
                  "
                  danger
                  @click="handlePurge"
                >
                  {{ $t('qing-kong-shi-xiao-wen-jian') }}
                </a-button>
                <template v-if="activeKey === COLLECTION_MAP.SOURCE">
                  <TagSelect
                    v-if="mediaTypeState === RESOURCE_TYPE.MATERIAL"
                    v-model="searchFrom.mediaType"
                    name="mediaType"
                    :label="$t('lei-xing')"
                    type="select"
                  />
                </template>
                <template v-if="activeKey === COLLECTION_MAP.RECYCLING_BIN">
                  <TagSelect
                    v-model="searchFrom.recycling_bin"
                    name="recycling_bin"
                    type="primary"
                  />
                </template>
              </div>
              <div v-if="checkable" class="flex-y-center gap-x-[8px]">
                <template v-if="!isRecyclingBin">
                  <a-button
                    v-if="
                      isMaterial && checkPermission(ActionListKey.TEAM_COPY)
                    "
                    :disabled="checkedList.length === 0"
                    :loading="loading.copy"
                    type="primary"
                    ghost
                    @click="handleCopyConfirm(checkedList, true)"
                  >
                    {{ $t('fu-zhi-dao-ge-ren-kong-jian') }}
                  </a-button>
                  <a-button
                    v-if="activeKey === COLLECTION_MAP.PIECES"
                    type="primary"
                    :disabled="checkedList.length === 0"
                    ghost
                    @click="handlePatchDownload(checkList, true)"
                  >
                    {{ $t('xia-zai-shi-pin') }}
                  </a-button>
                  <template v-if="currentShare === COLLECTION_SOURCE.TEAM">
                    <a-button
                      v-if="
                        checkable && checkPermission(ActionListKey.TEAM_DELETE)
                      "
                      type="primary"
                      :disabled="checkedList.length === 0"
                      :loading="loading.delete"
                      ghost
                      @click="handleDeleteConfirm(checkList, true)"
                    >
                      {{ $t('shan-chu') }}
                    </a-button>
                  </template>
                  <template v-else>
                    <a-button
                      v-if="checkable"
                      type="primary"
                      :disabled="checkedList.length === 0"
                      :loading="loading.delete"
                      ghost
                      @click="handleDeleteShare(checkList, true)"
                    >
                      {{ $t('cong-yu-wo-fen-xiang-zhong-yi-chu') }}
                    </a-button>
                  </template>
                </template>
                <template v-else>
                  <a-button
                    :disabled="checkedList.length === 0"
                    :loading="loading.recovery"
                    type="primary"
                    ghost
                    @click="handleRecovery(checkList, true)"
                  >
                    {{ $t('hui-fu') }}
                  </a-button>
                  <a-button
                    v-if="checkable"
                    type="primary"
                    :disabled="checkedList.length === 0"
                    :loading="loading.completely"
                    ghost
                    @click="handleDeleteCompletely(checkList, true)"
                  >
                    {{ $t('che-di-shan-chu') }}
                  </a-button>
                </template>
              </div>
            </template>
            <template v-if="isShowUpload" #extra>
              <FileUpload
                v-model="list"
                :description="`${$t('shang-chuan')}`"
                is-personal
                :type="mediaTypeState"
                :motion="allowPreview"
                :upload-params="{ upload_type: 1, model_type: activeKey }"
                :pageType="UPLOAD_TYPE.TEAM"
                @save="refreshUpload"
                @changeLoading="handleChangeLoading"
                @updateTotal="total += 1"
              />
            </template>
            <template #right="{ dataSource }">
              <a-popover v-if="checkDownloadable(dataSource)">
                <template #content>{{ $t('xia-zai-shi-pin') }}</template>
                <div
                  class="text-font-1 cursor-pointer w-[32px] flex-y-center justify-center h-[32px] rounded-[8px] hover:bg-back-2"
                >
                  <iconpark-icon
                    name="download"
                    size="18"
                    @click.stop="handlePatchDownload([dataSource.id])"
                  ></iconpark-icon>
                </div>
              </a-popover>
            </template>
            <template #menu="{ dataSource }">
              <a-menu
                v-if="!getSelfPerson(dataSource)"
                mode="vertical"
                @click="handleOnMenuClick($event, dataSource)"
              >
                <a-menu-item
                  v-if="opusOrPiecesTemp && dataSource.url?.length"
                  key="play-video"
                >
                  {{ $t('bo-fang-shi-pin') }}
                </a-menu-item>
                <template v-if="activeKey === COLLECTION_MAP.PIECES">
                  <!-- <a-menu-item key="open-opus">打开作品</a-menu-item> -->
                  <a-menu-item
                    v-if="
                      checkPermission(ActionListKey.TEAM_CREATE_PIECES_TEMPLATE)
                    "
                    key="pieces-temp"
                  >
                    {{ $t('chuang-jian-cheng-pian-mo-ban') }}
                  </a-menu-item>
                  <a-menu-item
                    v-if="
                      currentShare === COLLECTION_SOURCE.SHARE &&
                      checkPermission(ActionListKey.TEAM_SAVE)
                    "
                    key="save-as"
                  >
                    {{ $t('ling-cun-xin-zuo-pin-bing-bian-ji') }}
                  </a-menu-item>
                  <a-menu-item
                    v-if="
                      checkPermission(ActionListKey.TEAM_PUBLISH) &&
                      hasActionPermission('team_space_chengpian_promotion') &&
                      currentShare === COLLECTION_SOURCE.TEAM
                    "
                    key="publish"
                    :disabled="!dataSource?.url?.length"
                  >
                    {{ $t('tui-guang') }}
                  </a-menu-item>
                  <a-menu-item
                    v-if="
                      ActionPublish.isShow.value &&
                      currentShare === COLLECTION_SOURCE.TEAM
                    "
                    :key="ActionPublish.type"
                  >
                    <span class="inline-flex">
                      {{ $t('fa-bu-dao-you-yan-ping-tai') }}
                      <iconpark-icon
                        class="text-[16px] ml-[4px]"
                        name="diamond3d"
                      ></iconpark-icon>
                    </span>
                  </a-menu-item>
                </template>
                <a-menu-item
                  v-if="
                    checkPermission(ActionListKey.TEAM_CUSTEMCOVER) &&
                    currentShare !== COLLECTION_SOURCE.SHARE &&
                    [
                      COLLECTION_MAP.PIECES,
                      COLLECTION_MAP.PIECES_TEMPLATE,
                    ].includes(activeKey)
                  "
                  key="customCover"
                >
                  {{ $t('zi-ding-yi-feng-mian') }}
                </a-menu-item>
                <a-menu-item
                  v-if="
                    [
                      COLLECTION_MAP.PIECES_TEMPLATE,
                      COLLECTION_MAP.SOURCE,
                    ].includes(activeKey) &&
                    currentShare === COLLECTION_SOURCE.TEAM &&
                    mediaTypeState !== RESOURCE_TYPE.SOUND_EFFECT &&
                    checkPermission(ActionListKey.TEAM_BRAND_GUIDELINES) &&
                    !getSelfPerson(dataSource)
                  "
                  key="brand"
                >
                  {{
                    dataSource?.isBrand
                      ? $t('qu-xiao-pin-pai-gui-fan')
                      : $t('she-wei-pin-pai-gui-fan')
                  }}
                </a-menu-item>
                <!--回收站-->
                <template v-if="activeKey === COLLECTION_MAP.RECYCLING_BIN">
                  <a-menu-item key="recovery">{{ $t('hui-fu') }}</a-menu-item>
                  <a-menu-item key="delete-completely">
                    {{ $t('che-di-shan-chu') }}
                  </a-menu-item>
                </template>
                <template v-else>
                  <a-menu-item
                    v-if="
                      checkPermission(ActionListKey.TEAM_COPY) &&
                      !dataSource?.limited &&
                      !getSelfPerson(dataSource)
                    "
                    key="copy"
                  >
                    {{ $t('fu-zhi-dao-ge-ren-kong-jian') }}
                  </a-menu-item>
                  <template v-if="currentShare === COLLECTION_SOURCE.TEAM">
                    <a-menu-item
                      v-if="
                        checkPermission(ActionListKey.TEAM_RENAME) &&
                        !getSelfPerson(dataSource)
                      "
                      key="rename"
                    >
                      {{ $t('zhong-ming-ming') }}
                    </a-menu-item>
                    <a-menu-item
                      v-if="checkPermission(ActionListKey.TEAM_DELETE)"
                      key="delete"
                    >
                      {{ $t('shan-chu') }}
                    </a-menu-item>
                  </template>
                </template>
                <a-menu-item
                  v-if="currentShare === COLLECTION_SOURCE.SHARE"
                  key="delete-share"
                >
                  {{ $t('cong-yu-wo-fen-xiang-zhong-yi-chu') }}
                </a-menu-item>
              </a-menu>
            </template>
            <template
              v-if="
                activeKey === COLLECTION_MAP.SOURCE &&
                mediaTypeState !== RESOURCE_TYPE.STUDIO &&
                currentShare === COLLECTION_SOURCE.TEAM
              "
              #close="{ dataSource }"
            >
              <div
                v-if="
                  dataSource.status !== undefined &&
                  ![EXECUTION_STATUS.FINISHED].includes(dataSource.status)
                "
                class="absolute top-[10px] right-[10px] z-[11] cursor-pointer opacity-30 hover:opacity-100"
                @click.stop.prevent="handleDeleteUpload(dataSource)"
              >
                <a-popover :content="$t('shan-chu-ji-lu')">
                  <iconpark-icon name="close"></iconpark-icon>
                </a-popover>
              </div>
            </template>
            <template #empty>
              <div
                v-if="searchFrom.keyword"
                class="font-medium text-14 text-font-60"
              >
                {{ emptyText }}
              </div>
              <template v-else>
                <div class="font-medium text-16 text-font-80">
                  {{ EMPTY_TIP_MAP[currentShare][activeKey].title }}
                </div>
                <div
                  v-if="EMPTY_TIP_MAP?.[currentShare]?.[activeKey]?.description"
                  class="text-12 leading-[19px] text-font-60 mt-[8px] max-w-[410px]"
                >
                  {{ EMPTY_TIP_MAP?.[currentShare]?.[activeKey].description }}
                </div>
                <!-- ${ RESOURCE_TYPE_MAP[mediaTypeState]} -->
                <FileUpload
                  v-if="isShowUpload && currentShare === COLLECTION_SOURCE.TEAM"
                  v-model="list"
                  :description="`${$t('shang-chuan')}`"
                  is-personal
                  :type="mediaTypeState"
                  :motion="allowPreview"
                  :is-button="true"
                  :upload-params="{ upload_type: 1, model_type: activeKey }"
                  :pageType="UPLOAD_TYPE.TEAM"
                  class="mt-[24px]"
                  @save="refreshUpload"
                  @changeLoading="handleChangeLoading"
                  @updateTotal="total += 1"
                />
              </template>
              <div
                v-if="
                  list.length === 0 &&
                  activeKey === COLLECTION_MAP.RECYCLING_BIN
                "
                class="delete-tip"
              >
                {{
                  $t(
                    'hui-shou-zhan-de-nei-rong-mo-ren-bao-cun-userinforightsrecordrecycle-tian-hou-che-di-shan-chu-ka-pian-zai-shan-chu-qian-hui-xian-shi-sheng-yu-tian-shu-zhi-hou-jiang-yong-jiu-shan-chu-0',
                    [userInfo?.rights_record?.recycle]
                  )
                }}
              </div>
            </template>
            <template
              v-if="
                [COLLECTION_MAP.PIECES].includes(activeKey) &&
                currentShare === COLLECTION_SOURCE.TEAM
              "
              #task="{ dataSource }"
            >
              <TaskTray.Card
                v-if="dataSource.status !== undefined"
                class="!absolute inset-0 z-10"
                :data-source="{ ...dataSource }"
                :allow-cancel-queue="
                  checkPermission(ActionListKey.TEAM_CANCEL_QUEUE)
                "
                :description="$t('he-cheng-zhong')"
                :from="{
                  target: TARGET_FROM.EV,
                  source:
                    currentShare === COLLECTION_SOURCE.TEAM
                      ? SOURCE.TEAM_SPACE
                      : SOURCE.SHARE_WITH_ME,
                }"
                :shareToOuterUser="
                  hasActionPermission('team_space_share_to_outer_user')
                "
                @remove="deleteLoca"
                @reload="handleReload"
              />
            </template>
          </ListCard>
        </div>
      </template>
    </PageTabs>
  </div>
</template>
<script lang="ts" setup>
import { isEqual, remove, throttle } from 'lodash-es'
// import { ChannelEvent } from '@youyan/common'
import FileUpload from '@/features/fileUpload/index.vue'
import XCollect from '@/features/collect/index.vue'
import * as TaskTray from '@/features/taskTray'
import { Eye, usePlayView } from '@/features/pageList'
import ProjectEye from '@/features/pageList/components/preview/index.vue'
import ResourceLabel from '@/features/resourceLabel/index.vue'

import {
  getTeamSpace,
  copyTeamSpace,
  deleteTeamSpace,
  getTeamSpaceForRecycle,
  restoreRecycleForTeam,
  deleteRecycleForTeam,
  getUploadStatusList,
  updateTeamSpace,
  addTeamSpace,
  getShareList,
  deletePersonalUploadFile,
  deleteShare,
  copyToPersonal,
  createShareTemplate,
  editAsForShare,
  cancelBrand,
  reqRightsDisplay,
  cancelUploadFile,
  getUploadStatus,
} from '~/api'

import { useConfirm } from '~/hooks/useModal/modals/confirm'
import { useRequestAuth } from '~/hooks/useRequestAuth'
import { useCustomCover } from '~/hooks/useModal/modals/cover'
import { useActionIntercept } from '~/hooks/useActionIntercept'
import { getShareUrl } from '~/hooks/useModal/modals/share'
import { useVideoView } from '~/hooks/useModal/modals/view'
import { usePublishModal } from '~/hooks/useModal/modals/publish'
import { USER_LEVEL_KEY } from '~/api/interface'
import { getTargetForEventTracking } from '~/utils'
import { PAGE_SIZE } from '~/constants'
import { useTemplate } from '~/features/template'
import { TemplateShare } from '@/features/template/components/templateShare'
import { showPieces } from '~/hooks/useModal/modals/piecesView'
import { usePublishAction } from '@/features/listCardMenuActions/usePublishAction/index.tsx'
import { postRemoveSourceIsDeleteForSpace } from '~/api/module/space.ts'
import { downloadOssUrl } from '~/features/oss-upload/service'
import { YY_COMMON_GENERATE_LIST } from '~/constants/config'

const ActionPublish = usePublishAction('team')

const { hasActionPermission } = usePageAndActionPermissionData()

onBeforeUnmount(() => {
  ActionPublish.destroy()
})

const tabList = [
  {
    key: COLLECTION_SOURCE.TEAM,
    label: COLLECTION_SOURCE_MAP()[COLLECTION_SOURCE.TEAM],
  },
  {
    key: COLLECTION_SOURCE.SHARE,
    label: COLLECTION_SOURCE_MAP()[COLLECTION_SOURCE.SHARE],
  },
]
const route = useRoute()
const router = useRouter()
const editableConfig = ref()
const list = ref<any[]>([])
const activeKey = ref<number>(
  route?.query?.model_type
    ? Number(route?.query?.model_type)
    : COLLECTION_MAP.OPUS
)

const currentShare = ref<number>(
  route?.query?.share ? Number(route?.query?.share) : COLLECTION_SOURCE.TEAM
)
const baseSearch = {
  mediaType: 'all',
  recycling_bin: 'all',
  headEnd: 'all',
}
const searchFrom = reactive({
  ...baseSearch,
  keyword: (route?.query?.name || '') as string,
  project: 'all',
})
const mediaTypeState = ref<number>(
  route?.query?.resource_type
    ? Number(route?.query?.resource_type)
    : currentShare.value === COLLECTION_SOURCE.TEAM
    ? RESOURCE_TYPE.PERSON
    : RESOURCE_TYPE.MATERIAL
)
const checkList = ref<string[]>([])
const cardListRef = ref()
const loading = reactive({
  copy: false,
  delete: false,
  global: false,
  recovery: false,
  completely: false,
})
const emptyText = ref('暂无收藏内容')
// const PAGE_SIZE = 25
const queryParams = ref<any>({ model_type: 0 })
const total = ref(0) // 数据总条数
const userInfo: any = useUserInfo()
const timerHandler = ref()
const pollTimerHandler = ref()
const pollTaskRef = ref()
const isUnmounted = ref(false)
const isMoreMenu = ref(false)
const player = ref()
const cancelRefresh = ref(false)

const handlePurge = async () => {
  const res = await postRemoveSourceIsDeleteForSpace({
    model_type: activeKey.value,
  })
  message.success($t('shi-xiao-wen-jian-qing-li-cheng-gong'))
  list.value = remove(list.value, (item: any) => !res.data.includes(item.id))
  total.value = list.value.length
}

// 权限相关
const isAdmin =
  checkPermission(ActionListKey.TEAM_RENAME) &&
  checkPermission(ActionListKey.TEAM_DELETE) &&
  checkPermission(ActionListKey.TEAM_PUBLISH) &&
  checkPermission(ActionListKey.TEAM_CREATE_PIECES_TEMPLATE) &&
  checkPermission(ActionListKey.TEAM_BRAND_GUIDELINES)

// 允许上传
const isShowUpload = computed(
  () =>
    activeKey.value === COLLECTION_MAP.SOURCE &&
    currentShare.value !== COLLECTION_SOURCE.SHARE &&
    mediaTypeState.value !== RESOURCE_TYPE.STUDIO &&
    mediaTypeState.value !== RESOURCE_TYPE.PERSON &&
    checkPermission(ActionListKey.TEAM_UPLOAD)
)
const allowPreview = computed(() =>
  [RESOURCE_TYPE.HEAD, RESOURCE_TYPE.END].includes(mediaTypeState.value)
)

// 作品。成片模板
const opusOrPiecesTemp = computed(() =>
  [COLLECTION_MAP.OPUS, COLLECTION_MAP.PIECES_TEMPLATE].includes(
    activeKey.value
  )
)

// 是否为回收站
const isRecyclingBin = computed(
  () => activeKey.value === COLLECTION_MAP.RECYCLING_BIN
)

// 是定制人物
const getSelfPerson = (dataSource: any) => {
  return (
    dataSource.resource_type === RESOURCE_TYPE.PERSON &&
    activeKey.value === COLLECTION_MAP.SOURCE &&
    !dataSource.is_user_upload &&
    dataSource.config_type === 1
  )
}

const checkDownloadable = (dataSource: any) => {
  const canNoDown = [COLLECTION_MAP.PIECES].includes(activeKey.value)

  return !dataSource?.isDelete && dataSource?.url?.length && canNoDown
}

// 是否为团队空间
const isTeam = computed(() => currentShare.value === COLLECTION_SOURCE.TEAM)

const showBrand = () => {
  if (currentShare.value === COLLECTION_SOURCE.TEAM) {
    return (
      (activeKey.value === COLLECTION_MAP.SOURCE &&
        mediaTypeState.value !== RESOURCE_TYPE.SOUND_EFFECT) ||
      activeKey.value === COLLECTION_MAP.PIECES_TEMPLATE
    )
  }
  return false
}

// 素材不支持批量复制到个人空间
const isMaterial = computed(
  () =>
    (activeKey.value !== COLLECTION_MAP.SOURCE &&
      mediaTypeState.value === RESOURCE_TYPE.MATERIAL) ||
    (activeKey.value === COLLECTION_MAP.SOURCE &&
      mediaTypeState.value !== RESOURCE_TYPE.MATERIAL)
)

const { $t } = useNuxtApp()

const EMPTY_TIP_MAP: any = {
  [COLLECTION_SOURCE.TEAM]: {
    [COLLECTION_MAP.OPUS]: {
      title: $t('tuan-dui-de-zuo-pin-hui-xian-shi-zai-ci-chu'),
      description: $t(
        'cheng-yuan-fu-zhi-zuo-pin-dao-tuan-dui-kong-jian-li-suo-you-cheng-yuan-du-ke-yi-cha-kan-you-guan-li-yuan-guan-li'
      ),
    },
    [COLLECTION_MAP.PIECES]: {
      title: $t('tuan-dui-de-cheng-pian-hui-xian-shi-zai-ci-chu'),
      description: $t(
        'cheng-yuan-fu-zhi-cheng-pian-dao-tuan-dui-kong-jian-li-suo-you-cheng-yuan-du-ke-yi-cha-kan-you-guan-li-yuan-guan-li'
      ),
    },
    [COLLECTION_MAP.PIECES_TEMPLATE]: {
      title: $t('tuan-dui-de-cheng-pian-mo-ban-hui-xian-shi-zai-ci-chu'),
      description: $t(
        'cheng-yuan-fu-zhi-cheng-pian-mo-ban-dao-tuan-dui-kong-jian-li-suo-you-cheng-yuan-du-ke-yi-shi-yong-you-guan-li-yuan-guan-li'
      ),
    },
    [COLLECTION_MAP.SOURCE]: {
      title: $t('tuan-dui-de-zi-yuan-hui-xian-shi-ci-chu'),
      description: $t(
        'cheng-yuan-fu-zhi-zi-yuan-dao-tuan-dui-kong-jian-li-suo-you-cheng-yuan-du-ke-yi-shi-yong-you-guan-li-yuan-guan-li'
      ),
    },
    [COLLECTION_MAP.RECYCLING_BIN]: {
      title: $t('zan-wu-nei-rong'),
      description: '',
    },
  },
  [COLLECTION_SOURCE.SHARE]: {
    [COLLECTION_MAP.OPUS]: {
      title: $t('yu-wo-fen-xiang-de-zuo-pin-hui-xian-shi-zai-ci-chu'),
      description: $t(
        'qi-ta-cheng-yuan-fen-xiang-de-zuo-pin-ji-lu-ke-yi-zai-ci-cha-kan-zhi-chi-zai-ci-ye-mian-dui-yu-fen-xiang-de-zi-chan-guan-li'
      ),
    },
    [COLLECTION_MAP.PIECES]: {
      title: $t('yu-wo-fen-xiang-de-cheng-pian-hui-xian-shi-zai-ci-chu'),
      description: $t(
        'qi-ta-cheng-yuan-fen-xiang-de-cheng-pian-ji-lu-ke-yi-zai-ci-cha-kan-zhi-chi-zai-ci-ye-mian-dui-yu-fen-xiang-de-zi-chan-guan-li'
      ),
    },
    [COLLECTION_MAP.PIECES_TEMPLATE]: {
      title: $t('yu-wo-fen-xiang-de-cheng-pian-mo-ban-hui-xian-shi-zai-ci-chu'),
      description: $t(
        'qi-ta-cheng-yuan-fen-xiang-de-cheng-pian-mo-ban-ji-lu-ke-yi-zai-ci-cha-kan-zhi-chi-zai-ci-ye-mian-dui-yu-fen-xiang-de-zi-chan-guan-li'
      ),
    },
    [COLLECTION_MAP.SOURCE]: {
      title: $t('yu-wo-fen-xiang-de-zi-yuan-hui-xian-shi-zai-ci-chu'),
      description: $t(
        'qi-ta-cheng-yuan-fen-xiang-de-zi-yuan-ji-lu-ke-yi-zai-ci-cha-kan-zhi-chi-zai-ci-ye-mian-dui-yu-fen-xiang-de-zi-chan-guan-li'
      ),
    },
    [COLLECTION_MAP.RECYCLING_BIN]: {
      title: $t('zan-wu-nei-rong'),
      description: '',
    },
  },
}

const rightsList = ref<any[]>([])

const getRights = async () => {
  try {
    const response: any = await reqRightsDisplay()
    if (response.code === 0) {
      rightsList.value = response?.data?.rights ?? []
    }
  } catch (error) {
    console.error(error)
  }
}

const handleChangeLoading = (value = false) => {
  loading.global = value
}

const handleChangeTab = (value: number) => {
  currentShare.value = value
  activeKey.value = COLLECTION_MAP.OPUS
  if (isTeam.value && isAdmin) {
    editableConfig.value = { onSave: handleRename }
  }
}

// 获取收藏参数
const getCollectParams = (values: any) => {
  const requestParams: any = {
    is_user_upload: values.is_user_upload,
    model_id: values.model_id,
    model_type: values?.model_type ?? activeKey.value,
    source: currentShare.value,
  }
  if (activeKey.value === COLLECTION_MAP.SOURCE) {
    if (mediaTypeState.value === RESOURCE_TYPE.MATERIAL) {
      requestParams.media_type = values?.media_type
    }

    requestParams.resource_type = values?.resource_type ?? mediaTypeState.value
  }
  return requestParams
}

// 全局搜索
const handleOnSearch = (value: string) => {
  searchFrom.keyword = value
}

// 作品、成片模板播放视频上报
const handleTracker = (click = OPEN_ENTRANCE.CARD) => {
  trackEvent(TRACK_EVENT.CLICK_PLAY_VIDEO, {
    target:
      activeKey.value === COLLECTION_MAP.OPUS
        ? TARGET_FROM.Project
        : TARGET_FROM.EV,
    source:
      currentShare.value === COLLECTION_SOURCE.TEAM
        ? SOURCE.TEAM_SPACE
        : SOURCE.SHARE_WITH_ME,
    click,
  })
}

// 作品、成片模板播放视频
const handlePlayVideo = (record: any, click = OPEN_ENTRANCE.CARD) => {
  if (activeKey.value === COLLECTION_MAP.PIECES) {
    record.status = EXECUTION_STATUS.FINISHED
    showPieces({
      val: record,
      id: record.model_id,
      from: {
        target: TARGET_FROM.EV,
        source:
          currentShare.value === COLLECTION_SOURCE.TEAM
            ? SOURCE.TEAM_SPACE
            : SOURCE.SHARE_WITH_ME,
      },

      shareToOuterUser: hasActionPermission('team_space_share_to_outer_user'),
    })
  } else {
    useVideoView(record.url?.[0] || record.last_generate_record_data?.video_url)
  }

  handleTracker(click)
}

// 复制至空间
const handleCopyToTeamSpace = async (ids: number[], reset = false) => {
  if (ids.length > 1) {
    loading.copy = true
  }

  const requestMethod: any = {
    [COLLECTION_SOURCE.TEAM]: copyTeamSpace,
    [COLLECTION_SOURCE.SHARE]: copyToPersonal,
  }
  const response: any = await useRequestAuth(() =>
    requestMethod[currentShare.value]({ ids })
  )

  if (response.error_code === 0) {
    message.success($t('fu-zhi-dao-ge-ren-kong-jian-cheng-gong'))
    useUpdateUser()
    loading.copy = false
    if (checkList.value.length) {
      checkList.value = []
      cardListRef.value?.reset(reset)
    }
    trackEvent(TRACK_EVENT.YOUYAN_PLATFORM_COPYTOMY, {
      target: getTargetForEventTracking(activeKey.value, mediaTypeState.value),
      source:
        currentShare.value === COLLECTION_SOURCE.SHARE
          ? SOURCE.SHARE_WITH_ME
          : SOURCE.TEAM_SPACE,
      Batch: ids.length > 1 ? BATCH.ALL : BATCH.ONE,
    })
  } else {
    message.error($t('fu-zhi-dao-ge-ren-kong-jian-shi-bai'))
  }
}

const onSelectChange = (values: string[]) => {
  checkList.value = values
}

// 复制到团队空间确认
const handleCopyConfirm = (ids: number[], reset = false) => {
  if (useActionIntercept()) {
    return
  }
  handleCopyToTeamSpace(ids, reset)
}

// 修改名称
const handleRename = async (name: string, record: any) => {
  try {
    const response: any = await updateTeamSpace({
      id: record.id,
      name,
    })
    const currentRecord = list.value.find((item: any) => item.id === record.id)
    if (response.code === 0) {
      currentRecord.title = name
      message.success($t('xiu-gai-cheng-gong'))
      trackEvent(TRACK_EVENT.RENAME_TARGET, {
        target: getTargetForEventTracking(
          activeKey.value,
          mediaTypeState.value
        ),
        source: SOURCE.TEAM_SPACE,
        click: isMoreMenu.value ? OPEN_ENTRANCE.MORE : OPEN_ENTRANCE.CARD,
      })
      isMoreMenu.value = false
    } else {
      message.error($t('xiu-gai-shi-bai'))
      currentRecord.title = record.title
    }
  } catch (error) {
    console.error(error)
  }
}

const getCardName = (isShare?: boolean) => {
  let textTip = ''
  if (activeKey.value === COLLECTION_MAP.OPUS) {
    textTip = isShare ? $t('fen-xiang-kong-ge') : '' + $t('zuo-pin')
  } else if (activeKey.value === COLLECTION_MAP.PIECES) {
    textTip = isShare ? $t('fen-xiang-kong-ge') : '' + $t('cheng-pian')
  } else if (activeKey.value === COLLECTION_MAP.PIECES_TEMPLATE) {
    textTip = isShare ? $t('fen-xiang-kong-ge') : '' + $t('cheng-pian-mo-ban')
  } else {
    textTip = isShare
      ? $t('fen-xiang-kong-ge')
      : '' + RESOURCE_TYPE_MAP()[mediaTypeState.value]
  }
  return textTip
}

// 删除确认
const handleDeleteConfirm = (ids: string[], reset = false) => {
  const textTip = getCardName()
  useConfirm({
    icon: true,
    title: $t('shan-chu-texttip', [textTip]),
    description: $t(
      'userinfovaluerightsrecordrecycle-15-tian-nei-ke-zai-hui-shou-zhan-zhong-zhao-hui-yi-shan-texttip',
      [userInfo?.value?.rights_record?.recycle, textTip]
    ),
    okButtonProps: {
      danger: true,
    },
    okText: $t('shan-chu'),
    onOk: () => {
      handleDeleteSpace(ids, reset)
    },
  })
}

// 删除空间记录
const handleDeleteSpace = async (ids: string[], reset: boolean) => {
  try {
    const response: any = await useRequestAuth(() => deleteTeamSpace({ ids }))
    if (response.code === 0) {
      message.success($t('shan-chu-cheng-gong'))
      handleReload()
      trackEvent(TRACK_EVENT.DELETE_TARGET, {
        target: getTargetForEventTracking(
          activeKey.value,
          mediaTypeState.value
        ),
        source: SOURCE.TEAM_SPACE,
        Batch: ids.length > 1 ? BATCH.ALL : BATCH.ONE,
      })
      deleteLoca(ids, reset)
    } else {
      message.error($t('shan-chu-shi-bai'))
    }
  } catch (error) {
    console.error(error)
  }
}

// 打开到编辑器
const openEditor = (record: any) => {
  window.location.href = `/editor/${record?.project_id ?? record.id}/${
    record.secret_id
  }`
}

// 创作同款
const handleUseTemplate = (record: any) => {
  useTemplate(record)
}

// 卡片点击
const handleCardClick = (values: any) => {
  if (values.isDelete) {
    return
  }

  if (COLLECTION_MAP.OPUS === activeKey.value) {
    openEditor(values)
    trackEvent(TRACK_EVENT.OPEN_OPUS, {
      target: TARGET_FROM.Project,
      source: SOURCE.TEAM_SPACE,
      entrance: OPEN_ENTRANCE.CARD,
      permission: values.limited ? 'read' : 'edit',
    })
  }
  if (
    activeKey.value === COLLECTION_MAP.SOURCE &&
    [
      RESOURCE_TYPE.MATERIAL,
      RESOURCE_TYPE.PASTER,
      RESOURCE_TYPE.HEAD,
      RESOURCE_TYPE.END,
    ].includes(mediaTypeState.value)
  ) {
    usePlayView(values)
  }

  if (COLLECTION_MAP.PIECES === activeKey.value) {
    handlePlayVideo(values)
  }

  if (COLLECTION_MAP.PIECES_TEMPLATE === activeKey.value) {
    handleUseTemplate(values)
  }
}

// 打开编辑器对应功能
const jumpEditor = (record: any, type?: string) => {
  if (type) {
    window.location.href = `/editor/${record?.project_id ?? record.id}/${
      record.secret_id
    }?default=${type}`
  } else {
    window.location.href = `/editor/${record?.project_id ?? record.id}/${
      record.secret_id
    }`
  }
}

// 恢复
const handleRecovery = async (ids: string[], reset = false) => {
  loading.recovery = true
  try {
    const res = await restoreRecycleForTeam({ ids })
    loading.recovery = false
    if (res.code === 0) {
      message.success($t('hui-fu-cheng-gong'))
      for (const id of ids) {
        const record = list.value.find((item: any) => item.id === id)
        trackEvent(TRACK_EVENT.RESTORE_RECYCLE_BIN, {
          target: getTargetForEventTracking(
            record?.model_type,
            record.resource_type
          ),
          source: SOURCE.TEAM_SPACE,
          Batch: BATCH.ONE,
        })
      }
      deleteLoca(ids, reset)
    }
  } catch (error) {
    console.error(error)

    loading.recovery = false
  }
}

const deleteLoca = (ids: string[], reset = false) => {
  const l = list.value.length
  list.value = list.value.filter((item: any) => !ids.includes(item.id))
  total.value = Math.max(0, total.value - (l - list.value.length))
  cardListRef.value?.reset(reset)
}

// 彻底删除
const handleDeleteCompletely = (ids: string[], reset = false) => {
  useConfirm({
    icon: true,
    title: $t('shi-fou-che-di-shan-chu'),
    description: $t('che-di-shan-chu-bu-ke-zhao-hui'),
    okButtonProps: {
      danger: true,
    },
    okText: $t('shan-chu'),
    onOk: async () => {
      const res = await deleteRecycleForTeam({ ids })
      if (res.code === 0) {
        message.success($t('shan-chu-cheng-gong-0'))
        deleteLoca(ids, reset)
        trackEvent(TRACK_EVENT.DELETE_TARGET_COMPLETE, {
          source: SOURCE.TEAM_SPACE,
          Batch: ids.length > 1 ? BATCH.ALL : BATCH.ONE,
        })
        handleReload()
        useUpdateUser()
      }
    },
  })
}

// 批量下载视频
const handlePatchDownload = async (ids: number[], reset = false) => {
  const data = list.value.filter((item: any) => ids.includes(item.id))
  const downloadPromises = data.map(async (item) => {
    try {
      await downloadOssUrl(item.url?.[0], item.title)
    } catch (error) {
      console.error('Failed to download:', item.title, error)
    }
  })

  await Promise.all(downloadPromises)
  cardListRef.value.reset(reset)

  trackEvent(TRACK_EVENT.CLICK_DOWNLOAD_VIDEO, {
    source:
      currentShare.value === COLLECTION_SOURCE.SHARE
        ? SOURCE.SHARE_WITH_ME
        : SOURCE.TEAM_SPACE,
    Batch: ids?.length > 1 ? BATCH.ALL : BATCH.ONE,
    dataId: data.id,
    dataName: data.name,
  })
}

// 创建成片模板
const handleCreateTemplatePieces = async (id: string) => {
  try {
    const response: any = await (currentShare.value === COLLECTION_SOURCE.SHARE
      ? createShareTemplate
      : addTeamSpace)({ id })
    if (response.code === 0) {
      message.success($t('chuang-jian-cheng-gong-0'))
      trackEvent(TRACK_EVENT.CLICK_CREATE_TEMPLATE_FROM_CHENGPIAN, {
        source:
          currentShare.value === COLLECTION_SOURCE.SHARE
            ? SOURCE.SHARE_WITH_ME
            : SOURCE.TEAM_SPACE,
      })
    } else {
      message.error($t('chuang-jian-shi-bai'))
    }
  } catch (error) {
    console.error(error)
  }
}

// 删除与我分享
const handleDeleteShare = async (ids: string[], reset = false) => {
  try {
    const response: any = await deleteShare({ ids })
    if (response.code === 0) {
      message.success($t('yi-chu-cheng-gong-0'))
      deleteLoca(ids, reset)
      handleReload()
    } else {
      message.error($t('yi-chu-shi-bai'))
    }
  } catch (error) {
    console.error(error)
  }
}

// 另存新作品并编辑
const handleSaveAsShare = async (id: string) => {
  try {
    const response: any = await editAsForShare({ id })
    if (response.code === 0) {
      message.success($t('cao-zuo-cheng-gong'))
      trackEvent(TRACK_EVENT.SAVE_AS_NEW_OPUS_AND_EDIT, {
        source: SOURCE.SHARE_WITH_ME,
      })
    } else {
      message.error($t('cao-zuo-shi-bai'))
    }
  } catch (error) {
    console.error(error)
  }
}

// 取消品牌规范
const handleCancelBrand = async (ids: number[], isBrand: boolean) => {
  try {
    const response: any = await cancelBrand({
      brand_ids: ids,
      brand_guidelines: !isBrand,
    })
    if (response.code === 0) {
      message.success(
        isBrand ? $t('qu-xiao-cheng-gong-0') : $t('she-zhi-cheng-gong-0')
      )
      list.value?.forEach((item: any) => {
        if (ids.includes(item.id)) {
          if (isBrand) {
            trackEvent(TRACK_EVENT.CANCEL_BRAND_KIT, {
              target: getTargetForEventTracking(
                activeKey.value,
                mediaTypeState.value
              ),
              source: SOURCE.TEAM_SPACE,
              Batch: ids.length > 1 ? BATCH.ALL : BATCH.ONE,
            })
          } else {
            trackEvent(TRACK_EVENT.SET_AS_BRAND, {
              target: getTargetForEventTracking(
                activeKey.value,
                mediaTypeState.value
              ),
              source: SOURCE.TEAM_SPACE,
              click: 1,
            })
          }
          item.isBrand = !isBrand
        }
      })
    } else {
      message.error(isBrand ? $t('qu-xiao-shi-bai-0') : $t('she-zhi-shi-bai'))
    }
  } catch (error) {
    console.error(error)
  }
}

const handleOnMenuClick = (values: any, record: any) => {
  const { key } = values
  switch (key) {
    case 'copy':
      handleCopyConfirm([record.id])
      break
    case 'delete':
      handleDeleteConfirm([record.id])
      break
    case 'rename':
      record.edit = true
      isMoreMenu.value = true
      break
    case 'play-video':
      handlePlayVideo(record, OPEN_ENTRANCE.MORE)
      break
    case 'recovery':
      handleRecovery([record.id])
      break
    case 'delete-completely':
      handleDeleteCompletely([record.id])
      break
    case 'publish':
      usePublishModal(record, 'team')
      break
    case 'customCover':
      useCustomCover(
        {
          id: record.model_id,
          video_url: record?.url?.[0],
          model_type: activeKey.value,
        },
        () => handleGetSpaceList()
      )
      break
    case 'pieces-temp':
      handleCreateTemplatePieces(record.id)
      break
    case 'delete-share':
      handleDeleteShare([record.id])
      break
    case 'save-as':
      handleSaveAsShare(record.id)
      break
    case 'brand':
      handleCancelBrand([record.id], record.isBrand)
      break
    case ActionPublish.type:
      ActionPublish.action(record)
      break
    default:
      jumpEditor(record, key)
      break
  }
}

const reloadList = () => {
  const requestParams: any = {}
  if (mediaTypeState.value === RESOURCE_TYPE.MATERIAL) {
    if (searchFrom.mediaType !== 'all') {
      requestParams.media_type = searchFrom.mediaType
    }
  }
  handleGetSpaceList(requestParams, true)
}

const transferRecord = (values: any) => {
  const { failed_info, media_type, filesize, ...rest } = values
  const currentUser = userInfo.value
  const STATUS_TRANSFER: any = {
    [UPLOAD_STATUS.FINISHED]: {
      status: EXECUTION_STATUS.FINISHED,
      message: $t('shang-chuan-cheng-gong'),
    },
    [UPLOAD_STATUS.UPLOADING]: {
      status: EXECUTION_STATUS.PROCESSING,
      message: $t('shang-chuan-zhong'),
    },
    [UPLOAD_STATUS.NO_START]: {
      status: EXECUTION_STATUS.PROCESSING,
      message: $t('shang-chuan-zhong'),
    },
    [UPLOAD_STATUS.ERROR]: {
      status: EXECUTION_STATUS.ERROR,
      message: $t('shang-chuan-shi-bai'),
    },
    [UPLOAD_STATUS.PROCESSING]: {
      status: EXECUTION_STATUS.DATA_INIT,
      message: $t('jie-xi-zhong'),
    },
  }
  const temp: any = {}
  if (mediaTypeState.value === RESOURCE_TYPE.MATERIAL) {
    temp.media_type = media_type
  }

  return {
    ...temp,
    ...rest,
    ...failed_info,
    title: values?.filename,
    ...STATUS_TRANSFER[values?.upload_status],
    subMessage: '',
    type: getCardType(COLLECTION_MAP.SOURCE, mediaTypeState.value),
    avatar: currentUser?.logo_url ?? '',
    name: currentUser?.account_name ?? '',
    showImage: false,
    resourceType: mediaTypeState.value,
    rights: rightsList.value,
    size: filesize ? getFormateFileSize(filesize) : '',
  }
}

// 获取上传记录
const fetchUploadFile = async (
  length?: number,
  skip = false,
  preList: any[] = []
) => {
  if (currentShare.value === COLLECTION_SOURCE.SHARE) {
    return
  }

  try {
    clearTimeout(timerHandler.value)
    const response: any = await useRequestAuth(() =>
      getUploadStatusList({
        resource_type: mediaTypeState.value,
        upload_type: 1,
      })
    )
    if (response?.code === 0) {
      const tempList = preList?.length ? preList : [...list.value]
      for (const item of response?.data) {
        const index = tempList.findIndex(
          (record: any) => record?.upload_secret_id === item?.upload_secret_id
        )
        const temp = transferRecord(item)
        if (index === -1) {
          tempList.unshift(temp)
          total.value = total.value + 1
        } else {
          tempList.splice(index, 1, temp)
        }
      }
      tempList.sort(
        (recordA: any, recordB) =>
          new Date(recordB?.update_time).getTime() -
          new Date(recordA?.update_time).getTime()
      )
      list.value = tempList
      loading.global = false
      if (
        response?.data?.length &&
        activeKey.value === COLLECTION_MAP.SOURCE &&
        mediaTypeState.value !== RESOURCE_TYPE.STUDIO
      ) {
        const list = response?.data.filter(
          (f: any) => ![UPLOAD_STATUS.ERROR].includes(f.upload_status)
        )
        if (list.length) {
          timerHandler.value = setTimeout(() => {
            fetchUploadFile(response.data.length)
          }, 5000)
        } else {
          clearTimeout(timerHandler.value)
        }
      }
      if (!response?.data?.length && !skip && !cancelRefresh.value) {
        clearTimeout(timerHandler.value)
        reloadList()
      }
      if (
        typeof length === 'number' &&
        length > response.data.length &&
        !skip &&
        !cancelRefresh.value
      ) {
        reloadList()
      }

      if (!response?.data?.length) {
        loading.global = false
      }
    }
  } catch (error) {
    console.error(error)

    loading.global = false
  }
}

// 删除上传记录
const handleDeleteUpload = async (values: any) => {
  if (values?.upload_secret_id) {
    try {
      const isCancel = [
        EXECUTION_STATUS.DATA_INIT,
        EXECUTION_STATUS.PROCESSING,
      ].includes(values?.status)
      const method = isCancel ? cancelUploadFile : deletePersonalUploadFile
      const requestParams: any = {
        upload_secret_id: values?.upload_secret_id,
      }
      if (isCancel) {
        requestParams.delete_data = true
      }

      const response: any = await method(requestParams)
      if (response.code === 0) {
        message.success($t('shan-chu-cheng-gong-0'))
        list.value = list.value.filter((item: any) => values?.id !== item?.id)
      }
    } catch (error) {
      console.error(error)
    }
  }
}

const transferTimeText = (values: any) => {
  const timeNameMap: any = {
    [COLLECTION_MAP.OPUS]: $t('bian-ji-yu'),
    [COLLECTION_MAP.PIECES]: $t('dao-chu-yu'),
    [COLLECTION_MAP.PIECES_TEMPLATE]: $t('chuang-jian-yu'),
  }
  const timeValueMap: any = {
    [COLLECTION_MAP.OPUS]: 'time',
    [COLLECTION_MAP.PIECES]: 'finish_time',
    [COLLECTION_MAP.PIECES_TEMPLATE]: 'create_time',
  }
  if (activeKey.value === COLLECTION_MAP.RECYCLING_BIN) {
    return ''
  }

  if (timeNameMap[activeKey.value]) {
    return `${timeNameMap[activeKey.value] || ''}${
      currentShare.value === COLLECTION_SOURCE.SHARE
        ? values.source_time
        : values[timeValueMap[activeKey.value]]
    }`
  }
  if (
    activeKey.value === COLLECTION_MAP.SOURCE &&
    mediaTypeState.value === RESOURCE_TYPE.STUDIO
  ) {
    return $t('chuang-jian-yu-itemsourcetime', [values.create_time])
  }
}

const transformData = (values: any) => {
  const rest: any = {}
  if (
    activeKey.value === COLLECTION_MAP.PIECES &&
    values?.status !== undefined &&
    ![EXECUTION_STATUS.FINISHED, EXECUTION_STATUS.CANCELED].includes(
      values?.status
    )
  ) {
    rest.showImage = false
  }

  if (activeKey.value === COLLECTION_MAP.SOURCE) {
    rest.file_url = values?.file_url ?? values?.media_url ?? values?.cover
    rest.resourceType = mediaTypeState.value
    rest.rights = rightsList.value
  }
  return {
    ...values,
    // name: values.source_username || values.name,
    avatar: values.source_user_logo_url || values.avatar,
    type:
      COLLECTION_MAP.SOURCE === activeKey.value &&
      RESOURCE_TYPE.PASTER === mediaTypeState.value
        ? CARD_TYPE.MATERIAL
        : getCardType(
            COLLECTION_MAP.RECYCLING_BIN === activeKey.value
              ? values.model_type
              : activeKey.value,
            COLLECTION_MAP.RECYCLING_BIN === activeKey.value
              ? values?.resource_type
              : mediaTypeState.value
          ),
    time: transferTimeText(values),
    expired:
      activeKey.value === COLLECTION_MAP.RECYCLING_BIN
        ? values.recycle_bin_remain_retention_days
        : 0,
    tags: activeKey.value === COLLECTION_MAP.PIECES_TEMPLATE ? [] : values.tags,
    status: [COLLECTION_MAP.OPUS, COLLECTION_MAP.PIECES].includes(
      activeKey.value
    )
      ? values?.status
      : '',
    description: '',
    ...rest,
  }
}

// 是否允许轮询更新
const getAllowPoll = (array: any[]) =>
  array?.some((item: any) =>
    [
      EXECUTION_STATUS.NOT_STARTED,
      EXECUTION_STATUS.DATA_INIT,
      EXECUTION_STATUS.WAITING,
      EXECUTION_STATUS.PROCESSING,
    ].includes(item.status)
  )

const pollStatusList = async (
  tab: number,
  oldList: any[] = [],
  skip = false
) => {
  try {
    if (tab !== activeKey.value) {
      return
    }

    const response: any = await useRequestAuth(() =>
      getTeamSpace({
        task_status: [
          EXECUTION_STATUS.NOT_STARTED,
          EXECUTION_STATUS.DATA_INIT,
          EXECUTION_STATUS.WAITING,
          EXECUTION_STATUS.PROCESSING,
          EXECUTION_STATUS.ERROR,
        ].join(','),
        model_type: activeKey.value,
      })
    )
    if (response?.code === 0) {
      const newList = response.data
      const tempList: any[] = transformList(newList || []).map(transformData)
      if (tempList.length !== oldList.length && !skip) {
        handleReload()
        return
      }
      if (tempList.length) {
        for (const item of tempList) {
          const index = list.value.findIndex(
            (record: any) => record.id === item.id
          )
          if (index === -1) {
            // list.value.unshift(item)
          } else {
            list.value[index] = item
          }
        }
        const allowPoll = getAllowPoll(tempList)
        if (allowPoll && !isUnmounted.value && !searchFrom.keyword) {
          pollTimerHandler.value = setTimeout(() => {
            pollStatusList(tab, tempList)
          }, 3000)
        }
      }
    }
  } catch (error) {
    console.error(error)
  }
}

watch(
  () => activeKey.value,
  (oldTab) => {
    if (oldTab === COLLECTION_MAP.PIECES && pollTimerHandler.value) {
      clearTimeout(pollTimerHandler.value)
    }
  }
)

const allowExecPoll = (values: any[]) => {
  const allowPoll = getAllowPoll(values)
  if (
    [COLLECTION_MAP.PIECES].includes(activeKey.value) &&
    values.length &&
    allowPoll &&
    currentShare.value === COLLECTION_SOURCE.TEAM &&
    !searchFrom.keyword
  ) {
    pollStatusList(activeKey.value, [], true)
  }
}

const handleGetSpaceList = async (
  values?: any,
  reload = false,
  skip = false,
  reresh = true
) => {
  const userInfo = useUserInfo()
  const upLevel = [
    USER_LEVEL_KEY.TASTE,
    USER_LEVEL_KEY.PERSONAL,
    USER_LEVEL_KEY.PERSONAL_LITE,
  ] // 个人版、体验版
  if (pollTimerHandler.value) {
    clearTimeout(pollTimerHandler.value)
  }

  if (
    !userInfo.value?.user_id ||
    upLevel.includes(Number(userInfo.value?.rights_type))
  ) {
    return
  }

  loading.global = true
  const currentTab = activeKey.value
  const secondTab = mediaTypeState.value
  const shareTab = currentShare.value
  try {
    const rParams: any = {}
    if (activeKey.value !== COLLECTION_MAP.RECYCLING_BIN) {
      rParams.model_type = activeKey.value
    }

    if (activeKey.value === COLLECTION_MAP.SOURCE) {
      rParams.resource_type = mediaTypeState.value
    }

    if (searchFrom.keyword && !(route.query?.id || values?.id)) {
      rParams.name__icontains = searchFrom.keyword
    }

    if (route.query?.id) {
      rParams.id = route.query.id
    }

    const requestApis =
      currentShare.value === COLLECTION_SOURCE.TEAM
        ? COLLECTION_MAP.RECYCLING_BIN === activeKey.value
          ? getTeamSpaceForRecycle
          : getTeamSpace
        : getShareList
    const response: any = await useRequestAuth(() =>
      requestApis({
        page_size: PAGE_SIZE,
        page: 1,
        ...rParams,
        ...values,
      })
    )

    if (
      currentTab !== activeKey.value ||
      secondTab !== mediaTypeState.value ||
      shareTab !== currentShare.value
    ) {
      return
    }

    if (response.data) {
      if (response.data.next) {
        const temp = getUrlParams(response.data.next)
        queryParams.value = temp
      } else {
        queryParams.value = {}
      }

      if (!skip) {
        total.value = response.data.count
      }

      const arrData: any[] = transformList(response.data.results || []).map(
        transformData
      )
      let results = list.value
      if (reload || (!response?.data.next && !response?.data.previous)) {
        results = arrData
      } else {
        for (const item of arrData) {
          const index = results.findIndex(
            (record: any) => record.id === item.id
          )
          if (index === -1) {
            results.push(item)
          } else {
            results[index] = item
          }
        }
      }
      allowExecPoll(results)
      if (
        currentTab === COLLECTION_MAP.SOURCE &&
        secondTab !== RESOURCE_TYPE.STUDIO &&
        shareTab === COLLECTION_SOURCE.TEAM &&
        reresh
      ) {
        fetchUploadFile(undefined, true, results)
      } else {
        loading.global = false
        list.value = results
      }
    }
  } catch (err) {
    console.error(err)

    loading.global = false
  } finally {
    // loading.global = false
  }
}

const handleReload = (flag = false) => {
  handleGetSpaceList({}, true)
  if (flag) {
    pollTaskRef.value?.restart?.()
  }
}

const loadMore = throttle(() => {
  if (Object.keys(queryParams.value).length && !loading.global) {
    handleGetSpaceList(queryParams.value, false, true)
  }
}, 2000)

const refreshUpload = async (values: any) => {
  cancelRefresh.value = true
  if (typeof values === 'object') {
    const temp = transformList([values]).map(transformData)?.[0]
    const index = list.value.findIndex(
      (record: any) => record.upload_secret_id === values?.upload_secret_id
    )
    if (index !== -1) {
      list.value[index] = temp
    }
  } else {
    const index = list.value.findIndex(
      (record: any, index) => record.upload_secret_id === values
    )
    const response: any = await getUploadStatus({ upload_secret_id: values })
    if (response?.code === 0 && response?.data) {
      const temp = transferRecord(response?.data)
      if (index !== -1) {
        list.value[index] = temp
      }
    }
  }
}

watch(
  [activeKey, mediaTypeState, searchFrom, currentShare],
  ([tab, second, search, share], [oldTab, oldSecond, oldSearch, oldShare]) => {
    const requestParams: any =
      tab === COLLECTION_MAP.RECYCLING_BIN ? {} : { model_type: tab }

    if (tab !== oldTab) {
      Object.assign(searchFrom, baseSearch)
      if (tab !== COLLECTION_MAP.SOURCE) {
        mediaTypeState.value =
          currentShare.value === COLLECTION_SOURCE.TEAM
            ? RESOURCE_TYPE.PERSON
            : RESOURCE_TYPE.MATERIAL
      }
    }
    if (
      tab === COLLECTION_MAP.RECYCLING_BIN ||
      share === COLLECTION_SOURCE.SHARE
    ) {
      if (searchFrom.recycling_bin !== 'all') {
        requestParams.model_type = searchFrom.recycling_bin
        list.value = []
      }
      editableConfig.value = {}
    }
    if (
      tab !== oldTab ||
      second !== oldSecond ||
      share !== oldShare ||
      isEqual(search, oldSearch)
    ) {
      queryParams.value = {}
      list.value = []
      total.value = 0
      cardListRef.value?.reset()

      clearTimeout(timerHandler.value)
      cancelRefresh.value = false
    }
    if (tab === COLLECTION_MAP.SOURCE) {
      if (second === RESOURCE_TYPE.MATERIAL) {
        if (search.mediaType !== 'all') {
          requestParams.media_type = search.mediaType
          list.value = []
        }
      }
    }
    handleGetSpaceList(requestParams)
    queryParams.value = requestParams
  }
)

watch(
  [() => activeKey.value, () => mediaTypeState.value, () => currentShare.value],
  ([_key, _media, _share]) => {
    if (
      Number(route.query.model_type) !== _key ||
      Number(route.query.resource_type) !== _media ||
      Number(route.query.share) !== _share
    ) {
      // 路由和内容不匹配，则修改
      router.replace({
        query: {
          model_type: _key,
          resource_type: _media,
          share: _share,
        },
      })
    }

    trackEvent(
      _share === 2
        ? TRACK_EVENT.PAGE_SHARE_WITH_ME
        : TRACK_EVENT.PAGE_TEAM_SPACE,
      {
        target: getTargetForEventTracking(_key, _media),
      }
    )
  },
  { immediate: true }
)

watch([list, searchFrom], ([values, search]) => {
  if (values.length === 0) {
    if (search.keyword) {
      emptyText.value = $t(
        'wei-sou-dao-dui-ying-nei-rong-huan-ge-guan-jian-ci-shi-shi'
      )
    } else {
      emptyText.value = $t('zan-wu-nei-rong')
    }
  }
})

watch(
  () => route.query,
  (values: any) => {
    if (values?.share !== undefined) {
      currentShare.value = Number(values.share)
    }

    if (values?.model_type !== undefined) {
      activeKey.value = Number(values.model_type)
    }

    if (values?.resource_type !== undefined) {
      mediaTypeState.value = Number(values.resource_type)
    }

    if (values?.id) {
      searchFrom.keyword = values?.name
      handleGetSpaceList({ id: values?.id })
    }
  }
)

const source = computed(() =>
  currentShare.value === COLLECTION_SOURCE.TEAM
    ? SOURCE.TEAM_SPACE
    : SOURCE.SHARE_WITH_ME
)

provideResourceLocation({
  get source() {
    return source.value
  },
})

onMounted(() => {
  if (isAdmin) {
    editableConfig.value = { onSave: handleRename }
  }

  getRights()
  handleGetSpaceList()
  // router.replace({
  //   query: {
  //     model_type: activeKey.value,
  //     resource_type: mediaTypeState.value,
  //     share: currentShare.value,
  //   },
  // })
})

// onBroadcast(YY_COMMON_GENERATE_LIST, (data) => {
//   if (data.event === ChannelEvent.RELOAD) {
//     handleReload(true)
//   }
// })

onUnmounted(() => {
  if (timerHandler.value) {
    clearTimeout(timerHandler.value)
  }

  if (pollTimerHandler.value) {
    clearTimeout(pollTimerHandler.value)
  }

  isUnmounted.value = true
})
</script>
<style lang="scss" scoped>
.team {
  @apply h-full;
  :deep(.page-container) {
    padding-top: 20px !important;
  }
  .tab {
    @apply flex pt-[30px] px-[30px] gap-x-[32px];

    .tab-item {
      @apply relative text-[18px] leading-[25px] text-font-60 font-medium flex justify-center items-center cursor-pointer transition-colors duration-300;
      &.active {
        @apply text-[20px] leading-[32px] font-bold text-font-1;
      }

      &:hover {
        @apply text-font-1;
      }
    }
  }
  .content {
    @apply h-[calc(100%-74px)] relative;

    &.extra {
      height: calc(100% - 104px);
    }
    .icon-item {
      @apply flex justify-center items-center w-[28px] h-[28px] rounded-[50%] text-center cursor-pointer text-primary;
      background: $action-icon-bg;
      color: white;
      &:hover {
        background: $action-icon-bg-hover;
      }
    }

    .eye,
    .collection {
      background: none;
      &:hover {
        background: none;
      }
    }

    // .icon-item {
    //   @apply flex justify-center items-center w-[28px] h-[28px] rounded-[50%] text-center cursor-pointer text-primary;
    //   box-shadow: 0px 2px 6px 0px rgba(86, 80, 220, 0.1);
    //   opacity: 0.8;
    //   color: var(--text-primary-reverse);
    // }
    .tool {
      @apply absolute flex gap-x-[10px] top-[10px] left-[10px];
      .collection,
      .download,
      .brand,
      .share,
      .eye {
        opacity: 0;
      }

      .favorite {
        opacity: 1;
      }
    }

    :deep(.opus) {
      @apply absolute top-[10px] right-[44px] opacity-0;
    }

    .template {
      @apply absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] text-14 text-primary px-[11px] py-[6px] rounded-[8px] text-center cursor-pointer ease-linear opacity-0 whitespace-nowrap;
      background: rgba(255, 255, 255, 0.8);
      backdrop-filter: blur(3px);
      transition: opacity 0.3s;

      .icon-edit {
        @apply align-middle;
      }
      .label {
        @apply ml-[4px];
      }
    }

    :deep(.base-card) {
      &:hover {
        .collection,
        .download,
        .template,
        .eye,
        .opus,
        .brand,
        .share,
        .play-button {
          opacity: 1;
        }
      }
    }

    // .list-card {
    //   height: calc(100vh - 300px);
    // }

    .list-container {
      :deep(.list-card) {
        // height: calc(100vh - 300px);
        overflow-y: auto;
        padding-inline-end: 10px;
        padding-block-end: 65px;
      }
    }

    .extra {
      :deep(.list-card) {
        padding-block-end: 110px;
      }
    }

    .horizontal {
      @apply flex justify-center items-center w-[72px] h-[47px] bg-back-4 border-[1px] border-solid border-back-5;
      &:before {
        @apply w-full h-[30px] bg-back-1 border-solid border-[1px] border-back-5 my-[8px];
        content: '';
      }
    }
    .vertical {
      @apply flex justify-center items-center w-[72px] h-[47px] bg-back-4 border-[1px] border-solid border-back-5;
      &:before {
        @apply w-[32px] h-full bg-back-1 border-solid border-[1px] border-back-5 my-[8px];
        content: '';
      }
    }

    .delete-tip {
      @apply absolute w-full h-auto bottom-0 left-0 text-center text-font-40;
    }
  }

  .source-delete {
    @apply absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] text-14 px-[11px] py-[6px] rounded-[8px] text-center cursor-pointer ease-linear text-error-6 flex-y-center font-semibold;
    background: rgba(255, 240, 240, 0.8);
    backdrop-filter: blur(3px);
    transition: opacity 0.3s;
    white-space: nowrap;
    .icon-delete {
      @apply text-error-6;
    }
  }
}
</style>
